export function getEnvironment() {
  if (typeof window === 'undefined') {
    throw new Error(`Bridge Modern은 Node.js 환경을 지원하지 않아요.` + ` 혹시 SSR (Universal Rendering) 환경이시라면,` + ` Bridge 객체 생성이 Node.js 환경에서 이루어지고있는지 확인해주세요.`);
  }

  if (window.AndroidFunction) {
    return 'Android';
  }

  if (window.webkit) {
    return 'Cupertino';
  }

  return 'Web';
}